import { useNavigate } from "react-router";

import { useSession } from "0.Mine/2.Context/sessionContext";

export const useSignOut = () => {
  const { clearSession } = useSession();
  const navigate = useNavigate();

  const signOut = () => {
    clearSession();
    navigate("/signin", { replace: true });
  };

  return { signOut };
};
